<div v-show="isMenuExpanded" class="tt-o-filter__options tt-u-spacing--lg" role="menu" tabindex="-1"
  @keydown.esc.stop="close()"
  @keydown.tab.stop="handleTab($event)">
  <div class="tt-o-filter__options-header">
    <span class="tt-o-filter__options-heading" v-html="$msg('filters.header')"></span>
    <tt-button type="icon" @click="close" class="tt-o-filter__options-close" :aria-label="$msg('filters.close')"><tt-icon name="close" size="xs"></tt-icon></tt-button>
  </div>
  <tt-filter-options-group v-for="(filterGroup, index) in filterGroups"
                          @optionSelected="optionSelected"
                          :group="filterGroup.filter.group"
                          :name="filterGroup.filter.name"
                          :label="filterGroup.filter.title"
                          :options="filterGroup.filter.options"
                          :activeOptions="filterGroup.activeOptions"
                          :key="filterGroup.filter.name"></tt-filter-options-group>
  <div class="tt-o-filter__buttons">
    <tt-button type="primary" @click="applyFilters" class="tt-o-filter__apply" v-html="$msg('filters.apply')"></tt-button>
    <tt-button type="secondary" class="tt-o-filter__clear" @click="clearAllFilters" v-html="$msg('filters.clearAll')"></tt-button>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/objects/menu/filter-list.html